import { render, staticRenderFns } from "./YlmsHeader.vue?vue&type=template&id=11980818&scoped=true&"
import script from "./YlmsHeader.vue?vue&type=script&lang=ts&"
export * from "./YlmsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./YlmsHeader.vue?vue&type=style&index=0&id=11980818&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11980818",
  null
  
)

export default component.exports